import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { DatePickerAtom, TextFieldAtom } from "../../../../components/atoms/atom";
import { selectFormDataV2, selectReadonlyV2, updateFormFieldV2 } from "../../../../store/slices/aufmassV2Slice";

function AufmassFormV2({ validationErrors = {} }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const formData = useSelector(selectFormDataV2);
    const readonly = useSelector(selectReadonlyV2);

    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateFormFieldV2({ name, value }));
    };

    const handleDateChange = (date) => {
        dispatch(updateFormFieldV2({
            name: "date",
            value: date ? date.toISOString().split("T")[0] : "",
        }));
    };

    return (
        <div className="aufmass-panel-section aufmass-form-container">
            <div className="aufmass-panel-section-title">{t("aufmass.basic-information")}</div>
            <div className="aufmass-compact-fields">
                <TextFieldAtom
                    name="name"
                    label={t("aufmass.name")}
                    placeholder={t("aufmass.name")}
                    value={formData.name || ""}
                    onChange={handleChange}
                    required
                    error={validationErrors.name}
                    disabled={readonly}
                />
                <TextFieldAtom
                    name="number"
                    label={t("aufmass.number")}
                    placeholder={t("aufmass.number")}
                    value={formData.number || ""}
                    onChange={handleChange}
                    required
                    error={validationErrors.number}
                    disabled={readonly}
                />
                <DatePickerAtom
                    label={t("aufmass.date")}
                    selected={formData.date ? new Date(formData.date) : null}
                    onChange={handleDateChange}
                    error={validationErrors.date}
                    required
                    disabled={readonly}
                />
                <TextFieldAtom
                    label={t("aufmass.status.title")}
                    name="status"
                    value={formData.status || ""}
                    disabled
                />
            </div>
        </div>
    );
}

export default AufmassFormV2;
